import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import useSiteMeta from './useSiteMeta';

export type SEOProps = {
  title: string;
  description?: string;
  lang?: string;
};

const SEO: FC<SEOProps> = ({ title, description, lang = 'en' }) => {
  const site = useSiteMeta();
  const metaDescription = description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription
        },
        {
          property: `og:title`,
          content: title
        },
        {
          property: `og:description`,
          content: metaDescription
        },
        {
          property: `og:type`,
          content: `website`
        },
        {
          name: `twitter:card`,
          content: `summary`
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author
        },
        {
          name: `twitter:title`,
          content: title
        },
        {
          name: `twitter:description`,
          content: metaDescription
        }
      ]}
    />
  );
};

export default SEO;
